import React from "react";
import { Link } from "react-router-dom";
import Reveal from "./Reveal";
import { ArrowRight, Calendar, Heart, DollarSign, Clock, MessageCircle, Sparkles } from "lucide-react";

const DAYS = [
  { n: 1, title: "Define your top 5 life goals", icon: Sparkles, color: "#486a8f", bg: "#e7edf5" },
  { n: 2, title: "Build your health routine", icon: Heart, color: "#b94e4e", bg: "#f5e6e6" },
  { n: 3, title: "Organize your money plan", icon: DollarSign, color: "#3e6b52", bg: "#e9f0ec" },
  { n: 4, title: "Fix your daily schedule", icon: Clock, color: "#7a5fb0", bg: "#ede8f5" },
  { n: 5, title: "Improve one relationship", icon: MessageCircle, color: "#c18848", bg: "#f5ece0" },
  { n: 6, title: "Spirituality / reflection habit", icon: Sparkles, color: "#486a8f", bg: "#e7edf5" },
  { n: 7, title: "Build your 30-day roadmap", icon: Calendar, color: "#3e6b52", bg: "#e9f0ec" },
];

export default function ChallengeBlock() {
  return (
    <section id="challenge" className="py-24 md:py-32 bg-[#faf6ec]">
      <div className="max-w-5xl mx-auto px-6">
        <Reveal>
          <div className="text-center mb-12">
            <p className="font-mono-eyebrow text-[#486a8f] mb-3">FREE · 7-DAY CHALLENGE</p>
            <h2 className="font-display text-[40px] md:text-[56px] leading-[1.05] tracking-tight text-[#0f1724]">
              7 days to get your{" "}
              <span className="italic font-light text-[#486a8f]">life organized.</span>
            </h2>
            <p className="font-body text-[15px] md:text-[16px] text-[#4b5563] mt-5 max-w-xl mx-auto leading-relaxed">
              One small action per day. No app required to start. Free forever. Each day takes under 10 minutes.
            </p>
          </div>
        </Reveal>
        <Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-10">
            {DAYS.map((d) => {
              const Icon = d.icon;
              return (
                <div key={d.n} className="rounded-2xl bg-white border border-[#eadfc9] p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: d.bg }}>
                      <Icon size={15} style={{ color: d.color }} />
                    </div>
                    <p className="font-mono-eyebrow text-[#486a8f]">DAY {d.n}</p>
                  </div>
                  <p className="font-display text-[17px] text-[#0f1724] tracking-tight leading-tight">
                    {d.title}
                  </p>
                </div>
              );
            })}
          </div>
        </Reveal>
        <Reveal>
          <div className="text-center">
            <Link to="/challenge">
              <button
                data-testid="landing-challenge-cta"
                className="inline-flex items-center gap-2 h-13 px-7 rounded-full bg-[#3e6b52] hover:bg-[#345a45] text-white font-medium text-[15px]"
              >
                Start the free challenge <ArrowRight size={15} />
              </button>
            </Link>
            <p className="font-body text-[12px] text-[#6b7280] mt-3">
              Personal growth tool — not therapy or medical care.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
